$(window).on('load', function() {

  var lat, lng, loc, city, state, cityState, geocoder, map, center;

  var locationValue = $("#location").val();

  if($(window).width() > 700) {
    var defaultCenter = $('#center').val();
    defaultCenter = defaultCenter.split(',');

    var defaultCenterLat = parseFloat(defaultCenter[0]),
        defaultCenterLng = parseFloat(defaultCenter[1]),
        defaultZoom = parseFloat($('#zoom').val());

    map = new Maplace({ 
      controls_on_map: false,
      map_options: {
        zoom: defaultZoom,
        set_center: [defaultCenterLat,defaultCenterLng]
      },
      afterCloseInfowindow: function(){
        map.Load({
          map_options: {
            zoom: defaultZoom,
            set_center: [center.lat, center.lng], // center on group average
            pan_by: [getPanBy(defaultZoom), 0]            
          }
        });
      },
      styles: {
        'Wildfox': [
          /* --- LAND / BACKGROUND --- */
          { "featureType": "landscape", "elementType": "geometry.fill",
            "stylers": [{ "color": "#A8DCE8" }]  // Wildfox teal-land
          },
          /* --- WATER --- */
          { "featureType": "water", "elementType": "geometry.fill",
            "stylers": [{ "color": "#AFC4FF" }]  // lighter Wildfox blue water
          },
          { "featureType": "water", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]  // Wildfox navy for water labels
          },
          /* --- ROADS --- */
          { "featureType": "road", "elementType": "geometry.fill",
            "stylers": [{ "color": "#FF6E3B" }, { "lightness": 40 }] // brand orange
          },
          { "featureType": "road", "elementType": "geometry.stroke",
            "stylers": [{ "color": "#E25C2C" }, { "weight": 0.6 }]
          },
          { "featureType": "road", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]  // navy labels
          },
          /* --- POI (mountains, parks, schools, landmarks, etc.) --- */
          { "featureType": "poi", "elementType": "geometry.fill",
            "stylers": [{ "color": "#A8DCE8" }, { "lightness": 15 }]
          },
          // Remove ALL green POI text (mountains, “Mt Augusta”, etc.)
          { "featureType": "poi", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]  // navy fix
          },
          { "featureType": "poi.park", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]
          },
          { "featureType": "poi.attraction", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]
          },
          { "featureType": "poi.business", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]
          },
          { "featureType": "poi.sports_complex", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]
          },
          /* --- ADMIN AREAS (state lines, borders, etc.) --- */
          { "featureType": "administrative", "elementType": "geometry.stroke",
            "stylers": [{ "visibility": "off" }]
          },
          /* --- LABEL VISIBILITY / WEIGHT IMPROVEMENT --- */
          // Remove white halo → makes labels appear bolder
          { "featureType": "all", "elementType": "labels.text.stroke",
            "stylers": [{ "visibility": "off" }]
          },
          // Darken ALL labels for clean visibility
          { "featureType": "all", "elementType": "labels.text.fill",
            "stylers": [{ "color": "#1A2A6C" }]  // global Wildfox navy
          }
        ]
      }
    }).Load();

    $(window).resize(function(){		
      map.Load();
    });	

  }

  // load up the GOogle API Geocoder to get the lat / lng of the users current position. 
  var geocoder = new google.maps.Geocoder();

  if (!navigator.geolocation){
    //console.log('not geolocating')
  } else {
    navigator.geolocation.getCurrentPosition(
      function(position) {
        lat = position.coords.latitude;
        lng = position.coords.longitude;
        loadCityStateFromLatLng(lat,lng);
        getLocationsWithinRadiusOfLatLng(lat,lng,'load');

        setTimeout(() => {
            map.Load();
        }, 300);      
      },
      function(error) {
        // ⭐ NEW: fallback to default center
        getLocationsWithinRadiusOfLatLng(defaultCenterLat, defaultCenterLng, 'load');
        setTimeout(() => {
            map.Load();
        }, 300);
      }
    );	
  }

  $("#submit").click(function(e){	
    e.preventDefault();	
    var loc = $("#location").val(),
        prevLoc = $("#location").attr('data-locations');

    if(loc != prevLoc) {
      $("#location").attr('data-locations',loc);	
      geocoder.geocode( { 'address' : loc }, function( results, status ) {
        if( status == google.maps.GeocoderStatus.OK ) {
          //console.log('geocoded successfully');
          //console.log(results);
          getLocationsWithinRadiusOfLatLng(results[0].geometry.location.lat(),results[0].geometry.location.lng(),'load');
          $("#position").val(results[0].geometry.location.lat() + "," + results[0].geometry.location.lng());
        } else {
          alert( 'Geocode was not successful for the following reason: ' + status );
        }							
      });			
    }
  });


  function getLocationsWithinRadiusOfLatLng(lat,lng,type) {

    // Get boundaries for current location
    var locationRange = GeoLocation.buildLocationRange(lat,lng,200),
        minLat = locationRange.minLat,
        maxLat = locationRange.maxLat,
        minLon = locationRange.minLon,
        maxLon = locationRange.maxLon;        

    // Get locations from geo location and load them up
    var bookID = "1tSr5hFG9lvHJ-uV7qO9hycvDKUbTvZcSnD5QZrRHeOM",  
        sheetID = "0",
        qry = encodeURIComponent("SELECT B, C, D, E, F, G, H, I, J, L, M WHERE B = TRUE AND L IS NOT NULL AND L <= " + maxLat + " AND L >= " + minLat + " AND M IS NOT NULL AND M <= " + maxLon + " AND M >= " + minLon),
        url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry + "&gid=" + sheetID;
    
    $.ajax({
      type: "GET",
      url: url,
      datatype: "json",
      success: function(data){
        var locJSON,
            locHTML = '',
            locs = '',
            count = 0,
            zoom = 9;

        // Load the returned locations into the map.
        data = Papa.parse(data,{header: true});

        if(data == '{}') {
          locJSON = [{ 
            lat: lat, 
            lng: lng, 
            zoom: 14
          }] 
        } else {
          locs = data.data;
          $(locs).each(function(index){   
            var loclat = this.Latitude,
                loclon = this.Longitude;
            this["Distance"] = getDistance(lat,lng,loclat,loclon).toFixed(2);
          });

          locs = locs.sort((a, b) => a.Distance - b.Distance);  
          locJSON = generateLocationJSON(locs,lat,lng);
          locHTML = generateLocationHTML(locs,lat,lng);

          //update location list.
          $('.results').html(locHTML);
        }	

        if ($(window).width() > 700) {
          if (type === 'load') {
            const hasResults = locs && locs.length && locs[0].Latitude && locs[0].Longitude;

            if (hasResults) {
              // Compute average lat/lng across all locations
              center = getCenterOfLocations(locs);

              map.Load({
                locations: locJSON,
                map_options: {
                  zoom: zoom,
                  set_center: [center.lat, center.lng], // center on group average
                  pan_by: [getPanBy(zoom), 0]
                }
              });

              // Once markers render, let Maplace re-fit to bounds (for tighter framing)
              setTimeout(() => {
                if (map.ViewOnMap) map.ViewOnMap('all');
              }, 500);

            } else {
              // Fallback to your default center when no locations found
              map.Load({
                locations: locJSON,
                map_options: {
                  zoom: defaultZoom,
                  set_center: [defaultCenterLat, defaultCenterLng]
                }
              });
            }
          }

          if (type === 'set') {
            map.SetLocations(locJSON, false);
          }
        }
      } 
    });
  }

  // === WFF | Auto-center map on visible markers ===
  function getCenterOfLocations(locs) {
    if (!locs || !locs.length) return null;
    let latSum = 0, lngSum = 0;
    let count = 0;

    locs.forEach(loc => {
      if (loc.Latitude && loc.Longitude) {
        latSum += parseFloat(loc.Latitude);
        lngSum += parseFloat(loc.Longitude);
        count++;
      }
    });

    if (count === 0) return null;

    return {
      lat: latSum / count,
      lng: lngSum / count
    };
  }  

  function loadCityStateFromLatLng(lat,lng) {
    // Get city and state from the lat / lng
    var latlng = new google.maps.LatLng(lat,lng);

    geocoder.geocode({'latLng': latlng}, function(results, status) {
      if(status == google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          var indice=0;
          for (var j=0; j<results.length; j++){
            if(results[j].types[0]=='locality'){
              indice=j;
              break;
            }
          }
          for(var i=0; i<results[indice].address_components.length; i++){
            if (results[indice].address_components[i].types[0] == "locality") {
              //this is the object you are looking for
              if(results[indice].address_components[i].long_name != undefined) {
                city = results[indice].address_components[i].long_name;	
              }
            }
            if (results[indice].address_components[i].types[0] == "administrative_area_level_1") {
              //this is the object you are looking for
              if(results[indice].address_components[i].short_name != undefined) {
                state = results[indice].address_components[i].short_name;   
              }
            }
            if(city != undefined && state != undefined){
              cityState = city+', '+state;
              $("#location").val(cityState);
              $("#position").val(lat + ',' + lng);
              $("#location").attr('data-last',cityState);
            }
          }
        } else {
          alert("No results found");
        }
      } else {
        alert("Geocoder failed due to: " + status);
      }
    });	
  }

  function generateLocationJSON(l,locLat,locLon) {
    var locJSON = '';
    $(l).each(function(index){
      if(index < 10) {
        var name = this.Name,
            address = this.Address,
            city = this.City,
            state = this.State,
            zip = this.Zip,
            phone = this.Phone,
            website = this.Website,
            facebook = this.Facebook,
            lat = this.Latitude,
            lon = this.Longitude,
            distance = this.Distance;

        address += '<br>' + city;
        address += ', ' + state;
        address += ' ' + zip;

        if(locJSON.length > 0 ){ locJSON += ',' }
        locJSON += '{ "lat" : ' + lat + 
          ', "lon" : ' + lon +
          ', "zoom" : 17, "title" : "' + name.toUpperCase() + '"' +
          ', "html" : "<div class=\\"result\\">' +
          '<h3>' + name.toUpperCase() + '</h3>' +
          '<div class=\\"detail\\">' + address.toUpperCase();

        if(phone) { locJSON += '<br><br>Phone: ' + formatPhoneNumber(phone); }
        locJSON += '<br><br>';
        if(website) { locJSON += '<a href=\\"' + website + '\\" target=\\"_new\\">Website</a>';  }
        if(website && facebook) { locJSON += '&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;'; }
        if(facebook) { locJSON += '<a href=\\"' + facebook + '\\" target=\\"_new\\">Facebook</a>';  }      

        locJSON += '</div>'
        locJSON += '<div class=\\"miles\\">' 
        //locJSON += '<span class=\\"distance\\"></span><br>';

        daddr = address;
        daddr = daddr.replace(/<br>/g,' ');

        locJSON += '<a onclick=\\"getDirections(\'' + daddr + '\')\\" target=\\"_new\\">Directions</a></div>';
        if(phone) { locJSON += '<div class=\\"available\\"><strong>Call for Availability</strong></div>' }
        locJSON += '</div>';
        locJSON += '", "icon" : "https://cdn.shopify.com/s/files/1/0907/5703/8451/files/fox-head-shadowed.png?v=1763674570&width=50"}'
      }
    });
    locJSON = '[' + locJSON + ']'
    locJSON = JSON.parse(locJSON);
    return locJSON;  
  }

  function generateLocationHTML(l,locLat,locLon) {
    var html = '';

    $(l).each(function(index){  
      if(index < 10) {
        var name = this.Name,
            address = this.Address,
            city = this.City,
            state = this.State,
            zip = this.Zip,
            phone = this.Phone,
            website = this.Website,
            facebook = this.Facebook,
            lat = this.Latitude,
            lon = this.Longitude,
            distance = this.Distance;

        address += '<br>' + city;
        address += ', ' + state;
        address += ' ' + zip;    

        html += '<div class="result">';
        html += '<div class="sequence">' + (index+1) + '</div>';
        html += '<div class="detail"><strong>' + name.toUpperCase() + '</strong>' + address.toUpperCase();

        if(phone) { html += '<br><br>Phone: ' + formatPhoneNumber(phone); }
        html += '<br><br>';
        if(website) { html += '<a href="' + website + '" target="_new">Website</a>';  }
        if(website && facebook) { html += '&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;'; }
        if(facebook) { html += '<a href="' + facebook + '" target="_new">Facebook</a>';  }

        html += '</div>';
        html += '<div class="miles">' 
        //html += '<span class="distance"></span><br>';

        daddr = address;
        daddr = daddr.replace(/<br>/g,' ');

        html += '<a onclick="getDirections(\'' + daddr + '\')" target="_new">Directions</a></div>';
        if(phone) { html += '<div class="available"><strong>Please Call ahead for Availability</strong>' };
        html += '</div></div>';
      }
    });
    return html;
  }	

  $(document).on('click','.result',function(){
    map.ViewOnMap($(".result").index(this)+1);
  }) 
    
});


function getDirections(daddr) {
  saddr = document.getElementById("position").value;
  window.open('http://maps.google.com/maps?saddr=' + encodeURIComponent(saddr) + '&daddr=' + encodeURIComponent(daddr))
}


